import { useState, useEffect, useCallback } from 'react';
import supabase from '../supabase/supabase';

export const useDiscover = ({ genre = 'All', mood = 'All Moods', query = '' } = {}) => {
  const [drops, setDrops] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchDrops = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      let q = supabase
        .from('d2f_drops')
        .select(`
          id, title, genre, mood, tags, cover_url,
          min_price, suggested_price, unlock_count, is_published, created_at,
          artist:d2f_artists(id, name, slug, avatar_url, genre)
        `)
        .eq('is_published', true)
        .order('created_at', { ascending: false })
        .limit(50);

      if (genre && genre !== 'All') q = q.eq('genre', genre);
      if (mood  && mood  !== 'All Moods') q = q.eq('mood', mood);
      if (query) q = q.ilike('title', `%${query}%`);

      const { data, error: err } = await q;
      if (err) throw err;
      setDrops(data || []);
    } catch (e) {
      setError(e.message);
      setDrops([]);
    } finally {
      setLoading(false);
    }
  }, [genre, mood, query]);

  useEffect(() => { fetchDrops(); }, [fetchDrops]);

  return { drops, loading, error, refetch: fetchDrops };
};